import { ReactNode } from 'react';
import { SlidersHorizontal } from 'lucide-react';

interface MoreFiltersDropdownProps {
  /** Number of active "more" filters; drives the badge + active styling. */
  activeCount: number;
  /** Whether the dropdown popover is currently open. */
  open: boolean;
  /** Toggle the open state (wired to the trigger button). */
  onToggle: () => void;
  /** Close the dropdown (wired to the click-away overlay). */
  onClose: () => void;
  /** Button label. */
  label?: string;
  /** Filter controls rendered inside the popover. */
  children: ReactNode;
}

export default function MoreFiltersDropdown({
  activeCount,
  open,
  onToggle,
  onClose,
  label = 'More filters',
  children,
}: MoreFiltersDropdownProps) {
  return (
    <div className="relative">
      <button
        type="button"
        onClick={onToggle}
        className={`flex items-center gap-2 px-3 py-2 text-sm border rounded-lg transition-colors ${
          activeCount > 0
            ? 'border-primary-400 bg-primary-50 text-primary-700'
            : 'border-gray-300 text-gray-700 hover:bg-gray-50'
        }`}
      >
        <SlidersHorizontal className="w-4 h-4" />
        {label}
        {activeCount > 0 && (
          <span className="ml-1 rounded-full bg-primary-600 text-white text-xs px-1.5 py-0.5 leading-none">
            {activeCount}
          </span>
        )}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={onClose} />
          <div className="absolute right-0 top-full mt-2 z-50 w-80 bg-white border border-gray-200 rounded-lg shadow-xl p-4 space-y-4">
            {children}
          </div>
        </>
      )}
    </div>
  );
}
